
import { Component, Prop, Vue } from 'vue-property-decorator';
import { get } from '@/services/http';
import { isEmbedded, redirectExternal, redirectApp } from '@/utils/shopifyBridge';

@Component
export default class UpgradeVersion extends Vue {
    @Prop({default: false})
    public needUpgrade!: boolean;
    public installUrl: string = '';
    @Prop({default: ''})
    public shopName!: string;
    public showLoading: boolean = false;
    @Prop({default: null})
    public app!: any;
    public showDialog: boolean = true;

    public async upgradeVersion() {
      if (this.needUpgrade) {
        this.showLoading = true;
        const res: any = await get('/shopify/install?shop=' + this.shopName);
        this.installUrl = res.install_url;
        this.showLoading = false;
      }
      if (this.installUrl) {
          this.showLoading = true;
          redirectExternal(this.installUrl);
          this.installUrl = '';
          this.needUpgrade = false;
      }
    }
    
    public cancelUpgrade() {
      // Close the upgrade dialog
      this.$emit('update:needUpgrade', false);

      // Navigate to homepage and reload the app
      if (isEmbedded()) {
        // For embedded apps, use App Bridge to redirect to root path
        redirectApp('/');
      } else {
        // For standalone apps, use router and then reload
        this.$router.push('/');
      }
    }
}
